@if (display) {
    <div class="bg-surface-900 py-4 px-12 flex items-center justify-between relative">
        <a routerLink="/" class="flex items-center gap-4 py-2 no-underline text-inherit">
            <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 512 512"
            class="h-11 w-11"
            fill="none"
            style="enable-background:new 0 0 512 512;">
                <style type="text/css">
                    .st0{fill:#ffffff;}
                    .st1{fill:var(--color-brand-blue);}
                    .st2{fill:var(--color-brand-green);}
                </style>
                <g>
                    <path class="st1" d="
                        M80,0
                        h214
                        v376
                        h-296
                        v-296 a80,80 0 0 1 80,-80
                        z"
                    />

                    <path class="st0" d="
                        M295,0
                        h38
                        v412
                        h-335
                        v-38
                        h295
                        v-432
                        z"
                    />

                    <path class="st2" d="
                        M332,0
                        h100 a80,80 0 0 1 80,80
                        v352 a80,80 0 0 1 -80,80
                        h-352 a80,80 0 0 1 -80,-80
                        v-20
                        h332
                        v-432
                        z"
                    />
                </g>
            </svg>

            <h1 class="text-xl font-medium text-surface-0 w-36">{{ appName }}</h1>
        </a>

        <a
        pStyleClass="@next"
        enterFromClass="hidden"
        leaveToClass="hidden"
        [hideOnOutsideClick]="true"
        [hideOnResize]="true"
        resizeSelector=".resize-container-landing2"
        class="cursor-pointer block lg:hidden text-primary-contrast dark:text-surface-100 mt-1">
            <i class="pi pi-bars text-2xl!"></i>
        </a>

        <div class="items-center grow justify-between hidden lg:flex absolute lg:static w-full left-0 top-full px-12 lg:px-0 z-50 shadow lg:shadow-none bg-surface-900">
            <ul class="list-none p-0 py-4 lg:py-0 m-0 flex grow lg:items-center lg:justify-center text-surface-400 dark:text-surface-500 select-none flex-col lg:flex-row cursor-pointer">
                <li>
                    <a
                    class="flex items-center px-0 lg:px-8 py-4 hover:text-surface-500 dark:hover:text-surface-400 font-medium transition-colors duration-150 cursor-pointer"
                    [href]="marketingSite"
                    target="_blank">
                        <span>Apps</span>
                    </a>
                </li>

                <li>
                    <a
                    class="flex items-center px-0 lg:px-8 py-4 hover:text-surface-500 dark:hover:text-surface-400 font-medium transition-colors duration-150 cursor-pointer"
                    [href]="marketingSite + '/about'"
                    target="_blank">
                        <span>About Us</span>
                    </a>
                </li>

                <li>
                    <a
                    class="flex items-center px-0 lg:px-8 py-4 hover:text-surface-500 dark:hover:text-surface-400 font-medium transition-colors duration-150 cursor-pointer"
                    routerLink="/contact/us">
                        <span>Contact Us</span>
                    </a>
                </li>
            </ul>

            <div class="flex border-t lg:border-t-0 border-surface-700 lg:border-surface-800 py-4 lg:py-0 mt-4 lg:mt-0 gap-4">
                <!-- <button pButton [text]="true">
                    <span pButtonLabel>Register</span>
                </button> -->

                <p-button
                (click)="signIn();">
                    <span pButtonLabel>Sign In</span>
                    <i class="pi pi-sign-in ms-1"></i>
                </p-button>
            </div>
        </div>
    </div>
}
